import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { buildJsonLd } from '@/seo/jsonLd';

/**
 * Injects Schema.org JSON-LD structured data for the current route.
 * Kept separate from the runtime head/meta manager per project convention.
 */
export default function JsonLdManager() {
  const { pathname } = useLocation();

  useEffect(() => {
    const data = buildJsonLd(pathname);
    const scriptId = 'readdy-seo-jsonld';

    let script = document.getElementById(scriptId) as HTMLScriptElement | null;
    if (!script) {
      script = document.createElement('script');
      script.id = scriptId;
      script.type = 'application/ld+json';
      document.head.appendChild(script);
    }
    script.textContent = JSON.stringify(data);
  }, [pathname]);

  return null;
}